"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultJSON = exports.defaultObject = exports.defaultEnum = exports.defaultArray = exports.defaultBoolean = exports.defaultFloat = exports.defaultNumber = exports.defaultString = exports.makeDate = void 0;
const lodash_1 = __importDefault(require("lodash"));
const moment_1 = __importDefault(require("moment"));
// eslint-disable-next-line import/no-unresolved
const base_1 = __importDefault(require("./base"));
const makeDate = (date, extra = 0) => {
    let newDate = new Date();
    if (typeof date === 'string') {
        const momentDate = moment_1.default.utc(date, 'YYYY-MM-DD');
        momentDate.add(extra, 'd');
        newDate = momentDate.toDate();
    }
    else if (date instanceof Date) {
        newDate = date;
    }
    return newDate;
};
exports.makeDate = makeDate;
const defaultString = (value) => (value ? value.toString() : '');
exports.defaultString = defaultString;
const defaultNumber = (value) => {
    if (value !== null && value !== undefined) {
        const num = parseInt(value.toString(), 10);
        if (lodash_1.default.isFinite(num)) {
            return num;
        }
    }
    return 0;
};
exports.defaultNumber = defaultNumber;
const defaultFloat = (value) => {
    if (value !== null && value !== undefined) {
        const num = parseFloat(value.toString());
        if (lodash_1.default.isFinite(num)) {
            return num;
        }
    }
    return 0;
};
exports.defaultFloat = defaultFloat;
const defaultBoolean = (value) => !!value;
exports.defaultBoolean = defaultBoolean;
const defaultArray = (value) => {
    let list = [];
    if (Array.isArray(value)) {
        list = value;
    }
    else if (value) {
        list = [value];
    }
    return list;
};
exports.defaultArray = defaultArray;
function defaultEnum(value, enumObj) {
    return Object.values(enumObj).indexOf(value) > -1 && value !== null && value !== undefined
        ? value
        : '';
}
exports.defaultEnum = defaultEnum;
const defaultObject = (value) => {
    if (lodash_1.default.isPlainObject(value) || value instanceof base_1.default) {
        return value;
    }
    return {};
};
exports.defaultObject = defaultObject;
const defaultJSON = (json) => {
    let parsedJSON = {};
    if (typeof json === 'object') {
        parsedJSON = json;
    }
    else if (typeof json === 'string') {
        try {
            parsedJSON = JSON.parse(json);
        }
        catch (e) {
            console.warn(e, 'could not parse json');
        }
    }
    return parsedJSON;
};
exports.defaultJSON = defaultJSON;
